export type GeographicAreaType = 'WORLD' | 'SALES_ORGANIZATION' | 'REGION' | 'STORE' | 'ECOMMERCE';

const map = {
  WORLD: -1, SALES_ORGANIZATION: 15, REGION: 13, STORE: 7, ECOMMERCE: 50
};

export function toCode(type: GeographicAreaType): number {
  return map[type];
}
